import { CSSProperties } from 'react';
import { TooltipGrid } from '@infobis/ui-styles-utils';
import { TooltipGridProps } from "@infobis/ui-styles-utils/components/TooltipGrid/TooltipGrid";
import {
    BaseRowFormatter
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";
import { RowFormatter, TypedElement } from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/types";

export interface CropsTooltipProps<T> {
    elements: TypedElement<T>[]
    tooltipProps?: TooltipGridProps['tooltipProps']
    content?: TooltipGridProps['content']
    className?: string
    width?: number | string
    style?: CSSProperties
    flex?: boolean
    cellsInRow?: TooltipGridProps['cellsInRow']
    RowFormatter?: RowFormatter<T>
}

type TypedBaseChartTooltipProps<T> = CropsTooltipProps<T>
const BaseChartTooltip = <T,>(props: TypedBaseChartTooltipProps<T>) => {
    const {
        elements,
        tooltipProps,
        content,
        className = '',
        width,
        style = {},
        flex = true,
        cellsInRow,
        RowFormatter = BaseRowFormatter
    } = props

    return (
        <TooltipGrid
            className={className}
            ellipsis={false}
            tooltipProps={{ hideOnAnywhereClick: false, trigger: 'static', ...tooltipProps} }
            content={content}
            style={{ width: width, ...style }}
            flex={flex}
            cellsInRow={cellsInRow}
        >
            {elements.map(element => <RowFormatter key={element.id} element={element} />)}
        </TooltipGrid>
    )
}

export default BaseChartTooltip;